import { render } from "./Actualities.vue?vue&type=template&id=21044b46&scoped=true"
import script from "./Actualities.vue?vue&type=script&lang=js"
export * from "./Actualities.vue?vue&type=script&lang=js"

import "./Actualities.vue?vue&type=style&index=0&id=21044b46&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21044b46"]])

export default __exports__